<!--角色权限表-->
<template>
  <ls-table-layout>
    <div slot="search">
      <ls-search-form
        @search="onSearch"
        @reset="resetQuery"
        :formList="formList"
        ref="refSearchForm">
        <a-select slot="isEnable" v-model="queryParams.isEnable" allowClear>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleAdd">新增</a-button>
        <a-button type="primary" @click="handleEnabled(1)">启用</a-button>
        <a-button type="primary" @click="handleEnabled(0)">禁用</a-button>
        <addLicenseModal ref="addLicenseModalRef" @refreshFun="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          @selectedRowChange="selectedRowChange"
          :multi-select="true"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import addLicenseModal from './components/addLicenseModal'
import {
  apiGetBlackLicenseList,
  apiEnableBlacklicense
} from '@/api/scp/materialReservationManagement/materialReservation'

export default {
  name: 'BlackLicenseList',
  components: { addLicenseModal },
  data() {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetBlackLicenseList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        licenseNo: undefined,
        isEnable: undefined
      },
      formList: [
        { label: '车牌号', decorator: ['licenseNo'], type: 'input', attrs: { placeholder: '请输入' } },
        { label: '启用状态', decorator: ['isEnable'], type: 'isEnable', attrs: { placeholder: '请输入' } }
      ],
      // 表格字段
      columns: [
        { title: '车牌号', dataIndex: 'licenseNo', align: 'center', width: 100 },
        { title: '启用状态', dataIndex: 'isEnableName', align: 'center', width: 180 },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 140
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
          align: 'center',
          scopedSlots: { customRender: 'updateTime' },
          width: 140
        },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 80 }
      ],
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created() {
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleEnabled(isEnable) {
      if(this.selectedRowKeys?.length > 0) {
        apiEnableBlacklicense({
          ids: this.selectedRowKeys,
          isEnable
        }).then((response) => {
          if (response.code === 200) {
            this.$message.success(isEnable ? '启用成功!' : '禁用成功')
            this.handleOk()
          } else {
            this.$message.error(response.msg)
          }
        })
      }else {
        this.$message.warn('请勾选单据')
      }
    },
    handleOk() {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() })
    },
    // 新增
    handleAdd() {
      this.$refs.addLicenseModalRef.show()
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.selectedRowKeys = []
      this.selectedRows = []
      const params = Object.assign({}, this.queryParams, value)
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.queryParams = {
        licenseNo: undefined,
        isEnable: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less">
</style>
